import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  href,
  onClick,
  className = '',
  variant = 'primary',
  fullWidth = false
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 rounded-full px-8 py-4 text-lg tracking-wide transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#FF6B35] text-white hover:bg-[#E85A2D] shadow-lg hover:shadow-orange-500/30 focus:ring-[#FF6B35]',
    secondary: 'bg-white text-[#FF6B35] hover:bg-gray-50 shadow-md focus:ring-white',
    outline: 'border-2 border-[#FF6B35] text-[#FF6B35] hover:bg-[#FF6B35] hover:text-white focus:ring-[#FF6B35]'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
    }
    // If it's an anchor link to an ID, handle smooth scroll
    if (href?.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  if (href) {
    return <a href={href} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={handleClick} data-id="element-92">
        {children}
        <ArrowRight className="ml-2 h-5 w-5" data-id="element-93" />
      </a>;
  }
  return <button onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} data-id="element-94">
      {children}
      <ArrowRight className="ml-2 h-5 w-5" data-id="element-95" />
    </button>;
}